import React,{ useRef } from "react";
import { Toast } from 'primereact/toast';

import { Button, TextInputField } from "../../../helpers";
import { sendEmailOtp } from '../../../services/api/auth'

import GoogleAuthentication from './googleAuth'
import MicrosoftAuthentication from './microsoftAuth'


const LoginForm = (props) =>{
    const { handleLoginToggle, userDetails, handleUserDetails, setHash } = props
    const toast = useRef(null)

    const handleEmailOrMobileNumberResponse = (response) => {
        if(response.status === 200){

            toast.current?.show({severity:'success', summary: 'Success', detail:"An Otp was sent to your email", life: 3000})
            setHash(response.data)
            handleLoginToggle(true)
        }
        else{
            const error = response.data.error
            return toast.current.show({severity:'error', summary: 'Error', detail:error, life: 3000})
        }
    }

    const handleEmailValidation = async () => {   
        const emailValidationRegexCode = /^\s*[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+\s*$/
        const emailValidation = emailValidationRegexCode.test(userDetails)

        if(!emailValidation){
            return toast.current.show({severity:'error', summary: 'Error', detail:'Not a valid email', life: 3000})
        }
        
        const data = {
            emailId: userDetails
        }
        const response = await sendEmailOtp(data)

        handleEmailOrMobileNumberResponse(response)
    }

    const handleMobileValidation = async () => {
        if (userDetails.length !== 10){
            return toast.current.show({severity:'error', summary: 'Error', detail:'Mobile Number should be 10 characters', life: 3000});
        }

        const data = {
            phoneNum: userDetails
        }
        const response = await sendEmailOtp(data)

        handleEmailOrMobileNumberResponse(response)
    }

    const handleEmailOrMobileNumberSubmit = (event) => {
        event.preventDefault()

        if(!userDetails){
            return toast.current.show({severity:'error', summary: 'Error', detail:'Email shouldn\'t be empty', life: 3000}) // Email/Mobile Number shouldn\'t be empty
        }

        const numberValidationRegxCode = /^[0-9]+$/
        const numberValidation = numberValidationRegxCode.test(userDetails)
        if (numberValidation){
            //Mobile OTP Email
            //handleMobileValidation()
            return toast.current.show({severity:'error', summary: 'Error', detail:'Email Invalid', life: 3000})
        }
        else{
            handleEmailValidation()
        }
    }

    const otpSection = (
        <>
            <div className="mt-1 col-12">
                <Button label="SEND OTP" className="w-12 p-2 send-otp-btn" style={{backgroundColor: `${userDetails.includes("@procm") ? '#a0a3a3' : '#10a79f'}`}} onClick={handleEmailOrMobileNumberSubmit} />
            </div>
            <div className=" flex col-12 text-center">
                <p className=" flex flex-column text-sm align-item-center my-2"> Please enter email. You will receive OTP for logging in </p>
            </div>
        </>
    )

    const otpAlternateSection = (
        <>
            <hr style={{ width: "100%", backgroundColor: "white", marginTop: "25px" }} />
            <div className="flex col-12 text-center">
                <p className="text-sm my-2"> 
                    <span className="cursor-pointer" onClick={handleEmailOrMobileNumberSubmit}>Click here</span>&nbsp;
                    to login through otp. otp will be sent to registered mail id 
                </p>
            </div>
        </>
    )

    const dividerHTML = (
        <div className="flex flex-row mt-2">
            <hr style={{ width: "100px", height: "1px", backgroundColor: "black" }} />
            <p className="my-0 mx-1 text-sm">OR</p>
            <hr style={{ width: "100px", height: "1px", backgroundColor: "black" }} />
        </div>
    )

    const isProcmartUser = userDetails.includes("@procm")

    const authSection = (
        <>
            <GoogleAuthentication isProcmartUser={isProcmartUser} />
            { !isProcmartUser && <MicrosoftAuthentication /> }
        </>
    )

    return(
        <div className=" flex flex-column sm:mt-3 lg:flex-column col-12 lg:col-12">
        <div className="login-box mt-3 col-10">
            <Toast ref={toast} />
            <form className="login-box-content">
                <p className="font-medium text-xl m-2 text-center">LOGIN</p>
                <div className="flex flex-column col-12 mb-2 lg:col-12 lg:mb-0">
                    <TextInputField id="username" placeholder="Email Id" onChange={e => handleUserDetails(e.target.value)} value={userDetails} />
                </div>
                <div>{isProcmartUser ? [authSection, otpAlternateSection] : [otpSection, dividerHTML, authSection]}</div>
            </form>
        </div>
    </div>
    )
}

export default LoginForm